module.exports = __webpack_public_path__ + "img/ccwl-2.ebc31e17.png";